import { render, staticRenderFns } from "./DynamicPromiseView.vue?vue&type=template&id=ea2ca072&"
import script from "./DynamicPromiseView.vue?vue&type=script&lang=ts&"
export * from "./DynamicPromiseView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wannes.vermeulen/Repositories/dorst-app/dorst/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ea2ca072')) {
      api.createRecord('ea2ca072', component.options)
    } else {
      api.reload('ea2ca072', component.options)
    }
    module.hot.accept("./DynamicPromiseView.vue?vue&type=template&id=ea2ca072&", function () {
      api.rerender('ea2ca072', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/src/DynamicPromiseView.vue"
export default component.exports